jQuery( document ).ready( function( $ ) {

  $( '.teaser__note, .horizontal-teaser__note' ).on( 'mouseenter', function() {
    var $note = $( this ).children( '.note' );

    // Below the tablet breakpoint the note is centred against the viewport
    // rather than the icon, so its vertical position has to be set in JS.
    if ( $( window ).width() <= 768 ) {
      $note.css( 'top', this.getBoundingClientRect().bottom );
    } else {
      $note.css( 'top', '' );
    }

    $note.fadeIn();
  }).on( 'mouseleave', function() {
    $( this ).children( '.note' ).fadeOut();
  });

});
